import _extends from "../node_modules/@babel/runtime/helpers/esm/extends.es.js";
import _objectWithoutPropertiesLoose from "../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.es.js";
import * as React from "react";
import { ClearIcon } from "../icons/index.es.js";
import { useLocaleText } from "../internals/hooks/useUtils.es.js";
import { j as jsxRuntimeExports } from "../../../react/jsx-runtime.es.js";
import MUIIconButton from "../../material/IconButton/IconButton.es.js";
import { useSlotProps } from "../node_modules/@mui/base/utils/useSlotProps.es.js";
import MUIInputAdornment from "../../material/InputAdornment/InputAdornment.es.js";
const _excluded = ["clearable", "onClear", "InputProps", "sx", "slots", "slotProps"], _excluded2 = ["ownerState"];
const useClearableField = (props) => {
  const localeText = useLocaleText();
  const {
    clearable,
    onClear,
    InputProps,
    sx,
    slots,
    slotProps
  } = props, other = _objectWithoutPropertiesLoose(props, _excluded);
  const IconButton = (slots == null ? void 0 : slots.clearButton) ?? MUIIconButton;
  const _useSlotProps = useSlotProps({
    elementType: IconButton,
    externalSlotProps: slotProps == null ? void 0 : slotProps.clearButton,
    ownerState: {},
    className: "clearButton",
    additionalProps: {
      title: localeText.fieldClearLabel
    }
  }), iconButtonProps = _objectWithoutPropertiesLoose(_useSlotProps, _excluded2);
  const EndClearIcon = (slots == null ? void 0 : slots.clearIcon) ?? ClearIcon;
  const endClearIconProps = useSlotProps({
    elementType: EndClearIcon,
    externalSlotProps: slotProps == null ? void 0 : slotProps.clearIcon,
    ownerState: {}
  });
  return _extends({}, other, {
    InputProps: _extends({}, InputProps, {
      endAdornment: /* @__PURE__ */ jsxRuntimeExports.jsxs(React.Fragment, {
        children: [clearable && /* @__PURE__ */ jsxRuntimeExports.jsx(MUIInputAdornment, {
          position: "end",
          sx: {
            marginRight: (InputProps == null ? void 0 : InputProps.endAdornment) ? -1 : -1.5
          },
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(IconButton, _extends({}, iconButtonProps, {
            onClick: onClear,
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(EndClearIcon, _extends({
              fontSize: "small"
            }, endClearIconProps))
          }))
        }), InputProps == null ? void 0 : InputProps.endAdornment]
      })
    }),
    sx: [{
      "& .clearButton": {
        opacity: 1
      },
      "@media (pointer: fine)": {
        "& .clearButton": {
          opacity: 0
        },
        "&:hover, &:focus-within": {
          ".clearButton": {
            opacity: 1
          }
        }
      }
    }, ...Array.isArray(sx) ? sx : [sx]]
  });
};
export {
  useClearableField
};
//# sourceMappingURL=useClearableField.es.js.map
